import { Skeleton } from "@mui/material";
import { useHasScope } from "../../../../utils/Permission";

const PLACEHOLDER_ROWS = 12;

const TEXT_BAR = { width: '70%', height: 12 };

const CONTROL_BARS: Record<string, { width: number, height: number }> = {
    selectItem: { width: 14, height: 14 },
    detailItem: { width: 20, height: 20 },
};

const NAME_WIDTHS = ['82%', '64%', '90%', '71%', '86%', '58%', '76%', '88%', '68%', '80%'];

type Props =
    {
        hasDetails?: boolean
    }

/** Animated skeleton rows shown while a report loads */
export default function StoreReportLoadingRows({ hasDetails = true }: Props) {
    const canSeeDetails = useHasScope('reports:view-details');
    const canSelectRows = useHasScope(['stores:create', 'write-force-sync'], true);

    const columns = [
        ...(canSelectRows ? ["selectItem"] : []),
        "nameItem",
        ...(canSeeDetails ? ["idItem"] : []),
        "shopifyItem", "productItem", "statusItem",
        ...(canSeeDetails ? ["actionItem"] : []),
        "updatedItem",
        ...(canSeeDetails && hasDetails ? ["detailItem"] : []),
    ];

    const barFor = (column: string, row: number) => {
        if (column === "nameItem") return { width: NAME_WIDTHS[row % NAME_WIDTHS.length], height: 12 };
        return CONTROL_BARS[column] ?? TEXT_BAR;
    };

    return (
        <div>
            {Array.from({ length: PLACEHOLDER_ROWS }).map((_, row) => (
                <div key={row} className="products-list-view">
                    <div className="list-item">
                        <div className="item-line">
                            {columns.map((column) => (
                                <div key={column} className={`item-column ${column}`}>
                                    <Skeleton animation={false} {...barFor(column, row)} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
